import React from "react";
import * as ReactDOMClient from "react-dom/client";
import "./index.css";
import "./styles/global.css";
import "./styles/dark.css";
import "./styles/uniflo-brand.css";
import "./styles/clan-aigocy-theme.css";
import "react-loading-skeleton/dist/skeleton.css";

import "./styles/icons/icons.css";
// Initialise i18next (react-i18next) for its side effect before the first
// render so t()/useTranslation() resolve everywhere from the first paint.
import "./i18n";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./app/store";
import { installGlobalClientErrorHandlers } from "./utils/clientErrorReporter";
import { publishAppVersion } from "./utils/appVersion";
import axios from "axios";
import Cookies from "js-cookie";

// Cookies are not reliably JSON — services/api.js already try/catches this
// exact parse ("Token may be stored as JSON string / If not JSON, use raw
// value"). This module runs at import time, before React mounts, so a throw
// here is NOT catchable by ErrorBoundary and white-screens the whole app.
const readJsonCookie = (name) => {
  const raw = Cookies.get(name);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch (_error) {
    return raw;
  }
};

const token = readJsonCookie("token");
const parseThemeCookie = () => {
  const storedTheme = Cookies.get("theme");
  if (storedTheme) {
    try {
      return JSON.parse(storedTheme);
    } catch (_error) {
      return storedTheme;
    }
  }

  if (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) {
    return "dark";
  }

  return "light";
};

const initializeTheme = () => {
  const resolvedTheme = parseThemeCookie() === "dark" ? "dark" : "light";
  const isDarkTheme = resolvedTheme === "dark";
  document.documentElement.classList.toggle("dark", isDarkTheme);
  document.documentElement.dataset.theme = resolvedTheme;
  document.documentElement.style.colorScheme = resolvedTheme;
  if (document.body) {
    document.body.classList.toggle("dark", isDarkTheme);
    document.body.dataset.theme = resolvedTheme;
  }
};

if (token) axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
initializeTheme();
installGlobalClientErrorHandlers();
// Stamp the document with the marketing version and GitHub build, so support,
// QA and deploy checks can tell which bundle is running.
publishAppVersion();

const root = ReactDOMClient.createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </ErrorBoundary>
);
